import React from "react";
import { uniqueId } from "lodash";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function InviteIcon() {
  const gradientId = "paint0_linear" + uniqueId();
  const gradientId2 = "paint1_linear" + uniqueId();
  const gradientUrl = "url(#" + gradientId + ")";
  const gradientUrl2 = "url(#" + gradientId2 + ")";

  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M8.14575 9.35553C8.15793 8.65021 8.37398 7.96348 8.76782 7.37823C9.22125 6.67785 9.84906 6.10745 10.5896 5.72308C11.4527 5.27264 12.4155 5.04722 13.3889 5.06769C14.2937 5.05082 15.1903 5.24079 16.0105 5.62311C16.7244 5.94359 17.3329 6.45968 17.7656 7.11163C18.177 7.71335 18.3941 8.42669 18.3877 9.15558C18.4031 9.68863 18.2806 10.2166 18.0322 10.6885C17.8096 11.0971 17.529 11.4712 17.1991 11.7994C16.877 12.1104 16.2882 12.6436 15.444 13.399C15.2218 13.61 15.033 13.7989 14.8885 13.9544C14.7704 14.0919 14.6663 14.2407 14.5775 14.3987C14.5113 14.526 14.4592 14.6601 14.422 14.7986C14.422 14.9319 14.322 15.1652 14.2443 15.4985C14.2449 15.6532 14.2132 15.8063 14.1512 15.948C14.0893 16.0897 13.9984 16.217 13.8844 16.3215C13.7704 16.4261 13.6358 16.5057 13.4893 16.5553C13.3428 16.6048 13.1875 16.6232 13.0334 16.6093C12.8681 16.6146 12.7034 16.5869 12.5489 16.5278C12.3944 16.4686 12.2532 16.3793 12.1337 16.265C12.0046 16.1274 11.9053 15.9646 11.8422 15.7868C11.7791 15.609 11.7536 15.42 11.7671 15.2319C11.7505 14.7081 11.8412 14.1864 12.0337 13.6989C12.2018 13.2888 12.4426 12.9125 12.7446 12.5881C13.1184 12.1945 13.5153 11.8235 13.9332 11.4772C14.3665 11.0884 14.6886 10.7996 14.8774 10.6108C15.0749 10.4204 15.24 10.199 15.3662 9.95538C15.5032 9.71902 15.5759 9.45096 15.5773 9.17779C15.5803 8.91779 15.5273 8.66019 15.4219 8.4225C15.3165 8.18481 15.1611 7.97262 14.9663 7.80035C14.5346 7.41281 13.9685 7.20949 13.3889 7.23382C13.0887 7.20659 12.7861 7.24297 12.5009 7.34058C12.2157 7.4382 11.9543 7.59487 11.7338 7.80035C11.3122 8.28689 11.0014 8.85921 10.8229 9.47772C10.5896 10.2442 10.1564 10.5886 9.50098 10.5886C9.32116 10.5911 9.1427 10.557 8.97653 10.4883C8.81036 10.4195 8.65996 10.3175 8.53455 10.1887C8.30239 9.97145 8.1631 9.67297 8.14575 9.35553V9.35553ZM13.1445 20.5861C12.737 20.5982 12.34 20.4553 12.0337 20.1862C11.7406 19.8908 11.5762 19.4915 11.5762 19.0754C11.5762 18.6592 11.7406 18.26 12.0337 17.9645C12.1784 17.8182 12.3518 17.7032 12.5429 17.6268C12.734 17.5503 12.9388 17.5141 13.1445 17.5202C13.3505 17.512 13.5559 17.5474 13.7473 17.6239C13.9387 17.7005 14.1119 17.8165 14.2554 17.9645C14.4008 18.1094 14.5144 18.283 14.589 18.4743C14.6636 18.6656 14.6975 18.8703 14.6886 19.0754C14.6975 19.2825 14.6614 19.489 14.5828 19.6808C14.5042 19.8726 14.3849 20.045 14.2332 20.1862C13.9354 20.4549 13.5454 20.5982 13.1445 20.5861V20.5861Z"
        fill={gradientUrl}
      />
      <Path
        d="M23.6494 13C23.6494 18.8815 18.8815 23.6494 13 23.6494C7.11849 23.6494 2.35059 18.8815 2.35059 13C2.35059 7.11849 7.11849 2.35059 13 2.35059C18.8815 2.35059 23.6494 7.11849 23.6494 13Z"
        stroke={gradientUrl2}
        strokeWidth="3.07617"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="8.14575"
          y1="8.43228"
          x2="17.1991"
          y2="20.6411"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
        <LinearGradient
          id={gradientId2}
          x1="0.812499"
          y1="6.09864"
          x2="12.546"
          y2="30.0738"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
